import { render, staticRenderFns } from "./SeasonCommonScoreCorrectionEditor.vue?vue&type=template&id=672d06a8&scoped=true&"
import script from "./SeasonCommonScoreCorrectionEditor.vue?vue&type=script&lang=js&"
export * from "./SeasonCommonScoreCorrectionEditor.vue?vue&type=script&lang=js&"
import style0 from "./SeasonCommonScoreCorrectionEditor.vue?vue&type=style&index=0&id=672d06a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d06a8",
  null
  
)

export default component.exports